import React, { useEffect, useState, useRef } from 'react';

const SendResetPasswordEmail = () => {
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    const [email, setEmail] = useState('');
    const [emailSent, setEmailSent] = useState(false);
    const [requestError, setRequestError] = useState(null);

    const sendResetPasswordEmail = async () => {
        try {
            await fetch(`${apiBaseUrl}/send-reset-password-email`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ email }),
            });

            setEmailSent(true);
        } catch (error) {
            console.error('Error sending reset password email:', error);
            setRequestError('Error occurred. Try resending the email.');
        }
    }

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
    }

    const handleFormSubmit = (e) => {
        e.preventDefault();
        sendResetPasswordEmail();
    }

    return (
        <div className="page-background flex relative">
            {!emailSent ? (
                <form onSubmit={handleFormSubmit} className="bg-white p-6 rounded-lg shadow-md max-w-md mx-auto">
                    <label className="block mb-2" htmlFor="email">
                        Email
                    </label>
                    <input
                        type="email"
                        id="email"
                        value={email}
                        onChange={handleEmailChange}
                        className="block w-full px-4 py-2 border rounded-lg"
                    />
                    <button
                        className="px-4 py-2 bg-blue-500 hover:bg-blue-700 text-white rounded-lg mt-4"
                        type="submit"
                    >
                        Send
                    </button>
                    {requestError && <p className="text-red-500">{requestError}</p>}
                </form>
            ) : (
                <div className="bg-white p-6 rounded-lg shadow-md max-w-md mx-auto">
                    <p className="mb-4 text-lg">Check your email at <span className="font-bold">{email}</span></p>
                    <button
                        className="px-4 py-2 bg-blue-500 hover:bg-blue-700 text-white rounded-lg flex items-center justify-center mx-auto"
                        onClick={sendResetPasswordEmail}
                    >
                        Resend email
                    </button>
                    {requestError && <p className="text-red-500">{requestError}</p>}
                </div>
            )}
        </div>
    );
};

export default SendResetPasswordEmail;
